import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false, // 香港体检
    agentLogin: false, // 疫境求真代理人平台
    firstUse: 0,
    firstFree: 0,
  },
  mutations: {
    //荷载为true或false,是否登录
    checkLogin(state, isLog) {
      state.isLogin = isLog
    },

    //疫境求真代理人平台
    checkAgentLogin(state, isLog) {
      state.agentLogin = isLog
    },
    changeFirstUse(state, firstUse) {
      state.firstUse = firstUse
    },
    changeFirstFree(state, firstFree) {
      state.firstFree = firstFree
    },
  },
  actions: {
    // 香港体检
    login({ commit }, token) {
      localStorage.setItem('access_token', token)
      commit('checkLogin', true)
    },
    exit({ commit }) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      localStorage.removeItem('userInfo')
      commit('checkLogin', false)
    },

    toquestion() {},

    // 疫境求真代理人平台
    agentLogin({ commit }, token) {
      localStorage.setItem('agent_token', token)
      commit('checkAgentLogin', true)
    },
    agentExit({ commit }) {
      localStorage.removeItem('agent_token')
      localStorage.removeItem('agentType')
      commit('checkAgentLogin', false)
    },
  },
  modules: {},
})
